"use client";

import React from "react";
import Link from "next/link";
import { Settings } from "lucide-react";
import { DropdownMenuItem, DropdownMenuLabel } from "../../dropdown-menu";

interface AccountSectionProps {
  isEmployee: boolean;
  isAdmin: boolean;
}

/**
 * Account entry point. `/account` is the single hub for profile, picture,
 * passkeys, and password — so we link there once instead of repeating
 * "My Profile" / "Change Password" shortcuts that pointed at overlapping pages.
 */
export function AccountSection(_props: AccountSectionProps) {
  return (
    <>
      <DropdownMenuLabel className="px-3 py-2 text-xs font-medium text-muted-foreground uppercase tracking-wider">
        Account
      </DropdownMenuLabel>

      <DropdownMenuItem asChild>
        <Link href="/account" className="flex items-center px-3 py-2 cursor-pointer">
          <Settings className="mr-3 h-4 w-4 text-muted-foreground" />
          <div>
            <div className="font-medium text-foreground">Account &amp; security</div>
            <div className="text-xs text-muted-foreground">
              Profile, picture, passkeys &amp; password
            </div>
          </div>
        </Link>
      </DropdownMenuItem>
    </>
  );
}
